export const darkTheme = {
  bg: "#0A0A0F",
  bgLight: "#15171E",
  bgDark: "#0A0A0F",
  primary: "#007AFF",
  secondary: "#9747FF",
  navbar: "#15171E",
  arrow: "#AFAFB5",
  menu_primary_text: "#F2F3F4",
  menu_secondary_text: "#b1b2b3",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#1C1E27",
  card_light: "#191924",
  disabled: "#b1b2b3",
  shadow: "#00000060",
  white: "#FFFFFF",
  black: "#000000",
  green: "#12ff75",
  yellow: "#ffcc00",
  red: "#ef5350",
  orange: "#F7AD63",
  gradient_primary: "linear-gradient(135deg, #9747FF, #007AFF)",
  gradient_secondary: "linear-gradient(135deg, #007AFF, #9747FF)",
  glow_primary: "rgba(151, 71, 255, 0.3)",
  glow_secondary: "rgba(0, 122, 255, 0.3)",
};




export const lightTheme = {
  bg: "#f9f9f9",
  bgLight: "#FFFFFF",
  primary: "#007AFF",
  secondary: "#9747FF",
  disabled: "#b1b2b3",
  navbar: "#242B3F",
  arrow: "#AFAFB5",
  menu_primary_text: "#F2F3F4",
  menu_secondary_text: "#b1b2b3",
  table_header: "#242445",
  text_primary: "#404040",
  text_secondary: "#4d4c4c",
  card: "#FFFFFF",
  black: "#000000",
  white: "#FFFFFF",
  shadow: "#00000020",
  green: "#00ff6a",
  yellow: "#e8ba00",
  red: "#ef5350",
  orange: "#F7AD63",
};